export const SERVICEWORKER_REFRESH = 'SW_REFRESH';
export const SKIP_WAITING = 'SKIP_WAITING';
export const CLIENT_REFRESH = 'CLIENT_REFRESH';
